import { render, staticRenderFns } from "./worksnData.vue?vue&type=template&id=7536238f"
import script from "./worksnData.vue?vue&type=script&lang=js"
export * from "./worksnData.vue?vue&type=script&lang=js"
import style0 from "./worksnData.vue?vue&type=style&index=0&id=7536238f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports